import Weather from './Weather';
import React from 'react';
import '../css/App.css';
function App() {
    return (<div className="App">
        <Weather/>
    </div>);
}

export default App;
